import React, { useState } from "react";
import { ShieldCheck, Droplets, Hammer, CheckCircle } from "lucide-react";
import BookConsultModal from "../BookConsultModal";
import wp1 from '../../assets/terrace1.jpg';
import wp5 from "../../assets/terrace3.webp";

import wp10 from "../../assets/terrace10.jpg";
import wp11 from "../../assets/terrace11.jpg";
const TerraceWaterproofing = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      {/* HERO */}
      <section 
        className="relative h-[80vh] min-h-[500px] flex items-center"
        style={{ backgroundImage: `url(${wp1})`, backgroundSize: "cover", backgroundPosition: "center" }}
      >
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-2xl text-white">
            <h1 className="text-4xl md:text-5xl font-serif font-semibold leading-tight">
              Terrace Waterproofing
            </h1>
            <p className="mt-6 text-lg">
              Professional terrace waterproofing solutions to protect your home from leakage, dampness and long-term damage.
            </p>
            <div className="mt-10 flex gap-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="bg-amber-600 text-white px-8 py-3 rounded-lg font-medium hover:bg-amber-700 transition shadow-lg"
              >
                Get Free Inspection
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-white/40 text-white px-8 py-3 rounded-lg hover:bg-white/10 transition"
              >
                Talk to Expert
              </button>
            </div>
          </div>
        </div>
      </section>

      


      {/* FEATURES */}
      <section className="relative max-w-7xl mx-auto px-6 py-32 overflow-hidden">
  
  {/* luxury background */}
  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-gradient-to-br from-amber-200/20 via-blue-200/20 to-transparent rounded-full blur-[120px]" />
  <div className="absolute bottom-0 right-0 w-96 h-96 bg-amber-300/10 rounded-full blur-[100px]" />

  <div className="relative z-10">
    <h2 className="text-4xl md:text-5xl font-serif font-semibold  text-amber-700 text-center mb-4 tracking-tight">
      Why Terrace Waterproofing Matters
    </h2>
    <p className="text-center text-gray-700 mb-20 max-w-2xl mx-auto text-lg">
      Your terrace protects your entire home.  
      A small leak today can become a big structural problem tomorrow.
    </p>

    <div className="grid md:grid-cols-4 gap-12 ">
      {[
        {
          icon: <Droplets size={24} />,
          title: "Leak Protection",
          desc: "Stops rainwater from entering the slab and ceilings."
        },
        {
          icon: <ShieldCheck size={24} />,
          title: "Structural Safety",
          desc: "Prevents steel corrosion and concrete weakening."
        },
        {
          icon: <Hammer size={24} />,
          title: "Crack Control",
          desc: "Seals micro-cracks before they expand."
        },
        {
          icon: <CheckCircle size={24} />,
          title: "Long Durability",
          desc: "High-grade coatings last up to 10 years."
        }
      ].map((item, i) => (
        <div
          key={i}
          className="
            group relative 
            bg-white/60 backdrop-blur-2xl 
            border border-white/40
            p-12 rounded-[2.5rem]
            shadow-xl hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.25)]
            transition-all duration-700
            hover:-translate-y-4
          "
        >
          {/* glowing ring */}
          <div className="absolute inset-0 rounded-[2.5rem] bg-gradient-to-br from-amber-300/20 to-blue-300/20 opacity-0 group-hover:opacity-100 blur-xl transition" />

          <div className="relative z-10">
            <div className="
              w-16 h-16 mb-8 rounded-2xl 
              bg-gradient-to-br from-amber-400 to-amber-600 
              flex items-center justify-center 
              text-white shadow-lg
              group-hover:scale-110 group-hover:rotate-6
              transition-transform duration-500
            ">
              {item.icon}
            </div>

            <h3 className="font-semibold text-xl mb-3">
              {item.title}
            </h3>

            <p className="text-gray-600 text-sm leading-relaxed">
              {item.desc}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
 {/* WORK SHOWCASE */}
<section className="max-w-7xl mx-auto px-6 py-24">
  <div className="mb-14 text-center">
    <h2 className="text-4xl md:text-5xl font-serif font-semibold mb-4 text-amber-700 ">
      Our Waterproofing Projects
    </h2>
    <p className="text-gray-700 max-w-2xl mx-auto">
      Real terrace waterproofing transformations that protect homes 
      from leaks, dampness and structural damage.
    </p>
  </div>

  <div className="grid md:grid-cols-3 gap-8 items-stretch">
    
    {/* BIG IMAGE */}
    <div className="md:col-span-2 group relative overflow-hidden rounded-[2.5rem] shadow-2xl">
      <img
        src={wp10}
        alt="Main Project"
        className="w-full h-full object-cover min-h-[400px] transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition" />
    </div>

    {/* SIDE IMAGES */}
    <div className="grid grid-rows-2 gap-8">
      {[wp5, wp11].map((img, i) => (
        <div
          key={i}
          className="group relative overflow-hidden rounded-[2rem] shadow-xl"
        >
          <img
            src={img}
            alt="Project"
            className="w-full h-full object-cover min-h-[190px] transition-transform duration-700 group-hover:scale-110"
          />
          <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition" />
        </div>
      ))}
    </div>
  </div>
</section>

     
{/* PROCESS */}
<section className="relative bg-gradient-to-b from-white to-[#f9fafb] py-28 overflow-hidden">
  
  {/* subtle background blur blobs */}
  <div className="absolute -top-20 -left-20 w-72 h-72 bg-amber-200/20 rounded-full blur-3xl" />
  <div className="absolute -bottom-20 -right-20 w-72 h-72 bg-blue-200/20 rounded-full blur-3xl" />

  <div className="max-w-6xl mx-auto px-6 relative z-10">
    <h2 className="text-5xl font-serif font-semibold text-center  text-amber-700 mb-4">
      Our Waterproofing Process
    </h2>
    <p className="text-center text-gray-700 mb-20 max-w-xl mx-auto">
      A refined, step-by-step system designed to deliver long-lasting protection with zero compromise.
    </p>

    {/* golden line */}
    <div className="hidden md:block absolute left-1/2 top-[52%] w-[80%] h-[2px] bg-gradient-to-r from-transparent via-amber-400 to-transparent -translate-x-1/2" />

    <div className="grid md:grid-cols-4 gap-12 relative text-gray-700">
      {[
        {
          title: "Site Inspection",
          desc: "Advanced moisture and damage analysis.",
          icon: "🔍"
        },
        {
          title: "Surface Preparation",
          desc: "Deep cleaning & crack treatment.",
          icon: "🧹"
        },
        {
          title: "Chemical Treatment",
          desc: "Premium-grade waterproof layers.",
          icon: "🧪"
        },
        {
          title: "Final Testing",
          desc: "Multiple water tests before delivery.",
          icon: "✅"
        }
      ].map((step, i) => (
        <div
          key={i}
          className="group relative bg-white/70 backdrop-blur-xl border border-white/40 rounded-3xl p-10 text-center shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-3"
        >
          {/* floating number */}
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-8 h-8 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 text-white text-xs flex items-center justify-center shadow">
            {i + 1}
          </div>

          {/* icon */}
          <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-amber-100 to-amber-200 flex items-center justify-center text-2xl group-hover:scale-110 transition-transform">
            {step.icon}
          </div>

          <h3 className="font-semibold text-lg mb-2">
            {step.title}
          </h3>

          <p className="text-sm text-gray-500 leading-relaxed">
            {step.desc}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>

{/* EXTRA INFO SECTION (PAGE LENGTH BOOST) */}
<section className="relative max-w-7xl mx-auto px-6 py-24">
  <h2 className="text-4xl md:text-5xl font-serif font-semibold text-center text-amber-700 mb-6">
    Why Choose Our Terrace Waterproofing
  </h2>
  <p className="text-center text-gray-700 mb-20 max-w-2xl mx-auto text-lg">
    We don’t just apply chemicals — we deliver engineered waterproofing 
    systems designed for long-term protection and peace of mind.
  </p>

  <div className="grid md:grid-cols-3 gap-14">
    {[
      {
        title: "Certified Professionals",
        desc: "Trained technicians with years of on-field experience in terrace waterproofing."
      },
      {
        title: "Premium Materials",
        desc: "We use only industry-approved brands and high-performance chemicals."
      },
      {
        title: "No Mess Process",
        desc: "Clean execution with minimal disturbance to your daily routine."
      },
      {
        title: "Long Warranty",
        desc: "Service warranty with post-completion support."
      },
      {
        title: "Transparent Pricing",
        desc: "No hidden charges, clear scope and cost before starting."
      },
      {
        title: "Proven Results",
        desc: "Hundreds of successful terrace waterproofing projects delivered."
      }
    ].map((item, i) => (
      <div
        key={i}
        className="bg-white/70 backdrop-blur-xl border border-white/40 rounded-3xl p-10 shadow-xl hover:-translate-y-3 transition"
      >
        <h3 className="font-semibold text-xl mb-3">
          {item.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed">
          {item.desc}
        </p>
      </div>
    ))}
  </div>
</section>
{/* FAQ SECTION */}
<section className="relative max-w-6xl mx-auto px-6 py-24">
  <h2 className="text-4xl md:text-5xl font-serif font-semibold text-center text-amber-700 mb-6">
    Frequently Asked Questions
  </h2>
  <p className="text-center text-gray-700 mb-20 max-w-2xl mx-auto text-lg">
    Common questions our clients ask before starting terrace waterproofing.
  </p>

  <div className="space-y-8">
    {[
      {
        q: "How long does terrace waterproofing last?",
        a: "With proper surface preparation and premium materials, our waterproofing systems last between 8 to 12 years."
      },
      {
        q: "Do I need to vacate my home during work?",
        a: "No, terrace waterproofing is non-intrusive and does not disturb your daily routine."
      },
      {
        q: "How much time does the process take?",
        a: "Typically 2 to 5 days depending on terrace size and condition."
      },
      {
        q: "Is there any warranty?",
        a: "Yes, we provide service warranty along with post-work inspection support."
      }
    ].map((item, i) => (
      <div
        key={i}
        className="bg-white/70 backdrop-blur-xl border border-white/40 rounded-3xl p-8 shadow-lg"
      >
        <h3 className="font-semibold text-lg mb-2 text-gray-900">
          {item.q}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed">
          {item.a}
        </p>
      </div>
    ))}
  </div>
</section>

      
{/* CTA Section */}
<section className="bg-amber-50 py-24 flex flex-col items-center justify-center text-center">
  <div className="max-w-2xl">
    <h2 className="text-4xl md:text-5xl font-serif font-extrabold text-amber-700 mb-4">
      Protect Your Terrace Today
    </h2>
    <p className="text-gray-700 mb-8 text-lg">
      Schedule a free inspection and get expert solutions to prevent leaks, dampness, and structural damage.
    </p>
    <button
      onClick={() => setIsModalOpen(true)}
      className="inline-flex items-center px-10 py-4 bg-gradient-to-r from-amber-500 to-amber-700 text-white font-semibold rounded-full shadow-lg hover:scale-105 hover:shadow-xl transition-transform"
    >
      Book Free Inspection
    </button>
  </div>
  {/* Optional subtle graphic */}
  <div className="mt-12 w-32 h-2 bg-amber-300 rounded-full animate-pulse"></div>
</section>
      {/* MODAL */}
      <BookConsultModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  );
};




export default TerraceWaterproofing;
